import React, { CSSProperties, ReactElement, ReactNode, useRef } from "react";

interface Props {
  onClick: () => void;
  className?: string;
  title?: string;
  children?: ReactNode;
  disabled?: boolean;
  style?: CSSProperties;
  permitRpeatedClick?: boolean;
  disabledTimeAfterClicked?: number;
}

export default function Button(props: Props): ReactElement {
  const {
    onClick,
    className,
    title,
    children,
    disabled: propDisabled = false,
    style = {},
    permitRpeatedClick = false,
    disabledTimeAfterClicked = 300,
  } = props;
  const buttonRef = useRef<"disabled">();
  const [timeoutDisabled, setTimeoutDisabled] = React.useState(false);
  const handleClick = () => {
    if (buttonRef.current === "disabled" || timeoutDisabled) {
      return;
    }
    onClick !== undefined && onClick();
    if (!permitRpeatedClick) {
      buttonRef.current = "disabled";
      if (disabledTimeAfterClicked > 1000) {
        // 1秒以上ならStateで制御する
        // 視覚的にボタンを非活性にする
        setTimeoutDisabled(true);
      }
      setTimeout(() => {
        buttonRef.current = undefined;
        setTimeoutDisabled(false);
      }, disabledTimeAfterClicked);
    }
  };
  const disabled = propDisabled || timeoutDisabled;
  return (
    <div
      role={disabled ? undefined : "button"}
      tabIndex={0}
      className={`${
        disabled ? "opacity-50" : "cursor-pointer"
      } flex justify-center items-center ${className}`}
      onClick={() => {
        if (!disabled) {
          handleClick();
        }
      }}
      style={style}
    >
      {title !== undefined && <div>{title}</div>}
      {children !== undefined && <>{children}</>}
    </div>
  );
}
